module.exports = __webpack_public_path__ + "fonts/Jost-300-Light.837069e.otf";